import { atomWithStorage } from "jotai/utils";

export const meetAiBannerDismissedAtom = atomWithStorage<boolean>(
  "meet_ai_banner_dismissed",
  false,
);
